import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import TransactionHorizontal from "./TxHorizontal.png";
import TransactionVertical from "./TxVertical.png";
import Hidden from "@material-ui/core/Hidden";
import FilledButton from "../Buttons/Filled";
import generalStyle from "../../util/style";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    fontFamily: "'Roboto', sans-serif",
    marginTop: 120,
    paddingTop: 60,
    paddingLeft: 26,
    paddingRight: 26,
    backgroundColor: "#374EA2",
    paddingBottom: 60,
    [theme.breakpoints.up("md")]: {
      textAlign: "center",
      paddingTop: 100,
      paddingBottom: 100,
      justifyContent: "center",
    },
  },
  subtitle: {
    margin: 0,
    color: "#ffffff",
    marginBottom: 94
  },
  missionText: {
    fontSize: 18,
    fontWeight: 400,
    lineHeight: 1.7,
    marginBottom: 50,
    color: "#ffffff",
  },
  imageSpan: {
    minHeight: 120,
    display: "flex",
    alignItems: "center",
  },
  image: {
    maxHeight: 300,
    maxWidth: "100%",
  },
  tileTitle: {
    fontFamily: "'Cabin', sans-serif",
    fontSize: 26,
    fontWeight: 400,
    marginBottom: 10,
    marginTop: 15,
    color: "#374EA2",
  },
  description: {
    fontFamily: "'Roboto', sans-serif",
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 2,
    marginBottom: 60,
  },
  trackButton: {
    marginTop: 65,
  },
}));

export default function Transactions(props) {
  const classes = useStyles();
  const style = generalStyle();

  function navTracking() {
    window.location = "/track"
  }
  return (
    <Grid container className={classes.root}>
      <Grid item xs={12}>
        <Container maxWidth="lg">
          <Grid item xs={12} md={8} style={{ margin: "0 auto" }}>
            <h3 className={`${classes.subtitle} ${style.title}`}>Latest Transaction</h3>
            <Hidden mdUp>
              <img src={TransactionVertical} className={classes.image} />
            </Hidden>
            <Hidden smDown>
              <img src={TransactionHorizontal} className={classes.image} />
            </Hidden>
            <div className={classes.trackButton}>
              <FilledButton primary={false} onClick={navTracking}>View all transactions</FilledButton>
            </div>
          </Grid>
        </Container>
      </Grid>
    </Grid>
  );
}
